import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Flex,
    ModalCloseButton
} from '@chakra-ui/react';
import { InfoOutlineIcon } from "@chakra-ui/icons";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, message, isLoading = false }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size={'lg'}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Flex alignItems={'center'} gap={2}>
                        <InfoOutlineIcon color={'red.500'} pointerEvents="all" fontSize={'18px'} />
                        <Text fontSize={'20px'}>Confirm Deletion ?</Text>
                    </Flex>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody>
                    <Text  whiteSpace="pre-line">{message}</Text>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button 
                        colorScheme="gray"
                        variant="solid"
                        onClick={onClose}
                        size={'sm'} 
                    >
                        Cancel
                    </Button>
                    <Button colorScheme="brand" onClick={onConfirm} size={'sm'} isLoading={isLoading}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;
